import { firebaseShared } from "@shared/firebase.js";
import * as firebase from "@shared/firebase.js";
import * as environment from "@shared/environment.js";
import { dlog } from "@shared/utility.js";
import { priceLookup } from "@shared/priceLookup.js";

let allDevices = [];

function deviceWithID(id) {
    return allDevices.find(item => item.id === id);
}

function getAllDevices() {
    return allDevices ? [...allDevices] : [];
}

async function fetchDevices(force = false) {
    // Due to some weird firebase bug(?) where the auth token times out (I think in 30m), let's avoid trying to re-fetch feeds from firebase if we already have them.
    if (!force && allDevices.length > 0) {
        dlog("already fetched devices. bailing.");
        return;
    }
    
    try {
        dlog(`fetchDevices: start; collection: ${environment.currentDeviceCollectionName()}`);

        const collectionRef = firebase.collection(firebaseShared.db, environment.currentDeviceCollectionName());
        dlog(`fetchDevices: got collectionRef`);
        
        const snapshot = await firebaseShared.withRetry(() => firebase.getDocs(collectionRef));
        dlog(`fetchDevices: got snapshot`);

        const tempDevices = [];

        snapshot.forEach(doc => {
            tempDevices.push(doc.data());
        });
        
        allDevices = tempDevices;
        dlog("allDevices count: " + allDevices.length);
    } catch (error) {
        console.warn("fetchDevices failed after retries:", error);
        return;
    }

    dlog(`fetchDevices: ${allDevices.length} items in collection`);

    // Fetch prices if price endpoint is configured
    await fetchPricesForDevices();
}

async function fetchPricesForDevices() {
    if (!priceLookup.priceEndpointCallback || allDevices.length === 0) {
        console.warn("no price endpoint");
        return;
    }

    const skus = allDevices
        .map(device => device.sku)
        .filter(sku => sku);

    if (skus.length === 0) {
        console.warn("fetchPricesForDevices: No SKUs found in devices");
        return;
    }

    try {
        await priceLookup.fetchPrices(skus);
    } catch (error) {
        console.warn("fetchPricesForDevices: Failed to fetch prices:", error);
    }
}

export { deviceWithID, fetchDevices, getAllDevices };
